import { useTranslation } from 'react-i18next';

/** Shared frame for letter rows and the henvisningsoplysninger fields. */
export const referralLetterFrameClass =
  'overflow-hidden rounded-lg border border-ds-line bg-ds-card shadow-card';

/** One labelled text block of a referral letter (label above, pre-wrapped value). */
export function LetterDetailBlock({
  label,
  value,
  last,
}: {
  label: string;
  value: string | null;
  last?: boolean;
}) {
  return (
    <div className={`px-6 py-5 ${last ? '' : 'border-b border-ds-line'}`}>
      <div className="mb-2">
        <span className="text-xs font-medium uppercase tracking-wide text-ds-muted">{label}</span>
      </div>
      <div className="whitespace-pre-wrap text-sm text-ds-text">{value ?? '—'}</div>
    </div>
  );
}

export interface ReferralLetterFields {
  referral_diagnosis: string | null;
  requested_examination: string | null;
  anamnese: string | null;
}

/**
 * The "Henvisnings detaljer" content: diagnosis, requested examination and anamnese.
 * Shared by the referral page (/henvisninger/:id) and the patient page's Henvisning tab.
 */
export function ReferralLetterDetails({ referral }: { referral: ReferralLetterFields }) {
  const { t } = useTranslation();
  return (
    <section className={referralLetterFrameClass}>
      <LetterDetailBlock
        label={t('referrals.field_referral_diagnosis')}
        value={referral.referral_diagnosis}
      />
      <LetterDetailBlock
        label={t('referrals.field_requested_examination')}
        value={referral.requested_examination}
      />
      <LetterDetailBlock label={t('referrals.field_anamnese')} value={referral.anamnese} last />
    </section>
  );
}
